import lightGallery from 'lightgallery';

export default () => {
  const pageReadyCode = () => {
    // Check if we're on the correct page type.
    const pdfPage = document.querySelector('[data-pdf-file-page]');
    if (!pdfPage) {
      return;
    }

    const pdfFiles = pdfPage.querySelectorAll('[data-pdf-file-button]');

    // Create an array of your PDFs
    const dynamicPdfs = [ ...pdfFiles ].map((btn, index) => {
      return {
        src: btn.getAttribute('data-src'),
        iframe: true
      };
    });

    // Initialize lightGallery using dynamic mode
    const instance = lightGallery(pdfPage, {
      dynamic: true,
      dynamicEl: dynamicPdfs,
      licenseKey: 'EA872E91-6B5D-42AE-8A5E-021676FF3888',
      speed: 500
    });

    // Handle button click
    pdfFiles.forEach((pdfFile, index) => {
      pdfFile.addEventListener('click', (e) => {
        e.preventDefault();

        // Open the gallery at the correct index
        const idx = parseInt(pdfFile.getAttribute('data-index'));
        instance.openGallery(idx);
      });
    });

    // click first pdf file
    const firstPdfFile = pdfPage.querySelector('[data-pdf-file-button]');
    firstPdfFile.click();

    // redirect to parent page on lightgallery close using lgAfterClose event
    pdfPage.addEventListener('lgBeforeClose', (event) => {
      // parent page url is the same as the current page url before the /
      const parentPageUrl = window.location.href.split('/').slice(0, -1).join('/');
      window.location.href = parentPageUrl;
    });
  };
  apos.util.onReady(pageReadyCode);
};
